import Layout from '@/layout'

const infoRouter = {
  path: '',
  component: Layout,
  redirect: 'info',
  name: '客户资料',
  meta: {
    title: '客户资料',
    icon: 'el-icon-s-home'
  },
  children: [
    {
      path: 'info',
      name: 'customerInfo',
      meta: {
        title: '客户资料'
      },
      component: () => import('@/views/info/index')
    },
    {
      path: 'personal/information',
      name: 'personalInfo',
      meta: {
        title: '客户资料'
      },
      component: () => import('@/views/info/personal/information')
    },
    {
      path: 'personal/personalAuth',
      name: 'personalAuth',
      meta: {
        title: '个人实名认证'
      },
      component: () => import('@/views/info/personal/personalAuth')
    },
    {
      path: 'manageAddress',
      name: 'manageAddress',
      meta: {
        title: '管理地址'
      },
      component: () => import('@/views/info/manageAddress')
    },
    {
      path: 'manageAddress/addAddress',
      name: 'addAddress',
      meta: {
        title: '添加地址'
      },
      component: () => import('@/views/info/addAddress')
    },
    {
      path: 'manageAddress/updateAddress',
      name: 'updateAddress',
      meta: {
        title: '修改地址'
      },
      component: () => import('@/views/info/updateAddress')
    },
    {
      path: 'enterprise/enterpriseInfo',
      name: 'enterpriseInforise',
      meta: {
        title: '客户资料企业'
      },
      component: () => import('@/views/info/enterprise/enterpriseInfo')
    },
    {
      path: 'enterprise/companyAuth',
      name: 'companyAuth',
      meta: {
        title: '企业认证'
      },
      component: () => import('@/views/info/enterprise/companyAuth')
    },
    {
      path: 'trade/index',
      name: 'transRecord',
      meta: {
        title: '交易记录查询'
      },
      component: () => import('@/views/trade/index')
    },
    {
      path: 'enterprise/inforAuthcompay',
      name: 'inforAuthcompay',
      meta: {
        title: 'inforAuthcompay'
      },
      component: () => import('@/views/info/enterprise/inforAuthcompay')
    },
    {
      path: 'enterprise/enterpriseInfo',
      name: 'enterpriseInfo',
      meta: {
        title: 'enterpriseInfo'
      },
      component: () => import('@/views/info/enterprise/enterpriseInfo')
    },
    {
      path: 'enterprise/individualSsupplement',
      name: 'individualSsupplement',
      meta: {
        title: 'individualSsupplement'
      },
      component: () => import('@/views/info/enterprise/individualSsupplement')
    },
    {
      path: 'personalEnter',
      name: 'personalEnter',
      meta: {
        title: '个人资料'
      },
      component: () => import('@/components/personalEnter')
    }
  ]
}

export default infoRouter
